// extracted by mini-css-extract-plugin
export default {"meta-row":"MetaRow_meta-row__cYbAq"};